// import swal from 'sweetalert';
import FIREBASE from "../config/FIREBASE";
import {
  dispatchError,
  dispatchLoading,
  dispatchSuccess,
} from "../utils/dispatch/index";

import { ADMINS_LOGIN, ADMINS_LOGOUT, API_TIMEOUT } from "../utils";
import { API_HOHOLOK } from "../utils";
import axios from "axios";

export const LOGIN_USER = "LOGIN_USER";
export const CHECK_LOGIN = "CHECK_LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_PROFILE = "UPDATE_PROFILE";

export const loginUser = (email, password, setLoginProses, navigate) => {
  FIREBASE.auth()
    .signInWithEmailAndPassword(email, password)
    .then((res) => {
      FIREBASE.database()
        .ref(`users/${res.user.uid}`)
        .once("value")
        .then((resDB) => {
          const userData = resDB.val();

          if (!userData) {
            alert("Data pengguna tidak ditemukan.");
            setLoginProses(false);
            return;
          }

          // Cek ke API backend HoHolok
          axios({
            method: "get",
            url: API_HOHOLOK + "users/uid/" + userData.uid,
            timeout: API_TIMEOUT,
          })
            .then((response) => {
              const data = response.data;

              if (response.status !== 200 || !data.status) {
                alert("Pengguna tidak terdaftar dalam sistem.");
                setLoginProses(false);
                return;
              }

              let curr = {};

              if (data.status === "admin") {
                curr = {
                  dinas_id: data.id_dinas,
                  nama_dinas: data.nama_dinas,
                  nama: data.nama_admin,
                  status: data.status,
                  profil: data.profil,
                  email: data.email,
                  uid: data.id_admin,
                  uid_RSS: data.uid_RSS,
                  id_dinas: data.id_dinas,
                };
              } else {
                curr = {
                  perusahaan: data.id_perusahaan,
                  nama_perusahaan: data.nama_perusahaan,
                  nama: data.nama_user,
                  status: data.status,
                  profil: data.profil,
                  email: data.email,
                  uid: data.id_user,
                  uid_RSS: data.uid_RSS,
                  jenis_perusahaan: data.jenis_perusahaan,
                  id_perusahaan: data.id_perusahaan,
                };
              }

              try {
                localStorage.setItem("user", JSON.stringify(curr));
              } catch (e) {
                alert("Gagal menyimpan data login. Silakan coba lagi.");
                setLoginProses(false);
                return;
              }

              navigate("/dashboards/proyek");
              setLoginProses(false);
            })
            .catch((error) => {
              let errorMessage = "Gagal terhubung ke sistem backend.";

              if (error.response) {
                // Server merespons dengan status error
                const status = error.response.status;
                const data = error.response.data;

                switch (status) {
                  case 404:
                    errorMessage =
                      "Endpoint tidak ditemukan. Periksa konfigurasi API.";
                    break;
                  case 500:
                    errorMessage = "Server error. Silakan coba lagi nanti.";
                    break;
                  case 401:
                    errorMessage = "Unauthorized. Sesi login tidak valid.";
                    break;
                  case 403:
                    errorMessage = "Forbidden. Akses ditolak.";
                    break;
                  default:
                    errorMessage = `Error ${status}: ${
                      data?.message || "Terjadi kesalahan pada server"
                    }`;
                }
              } else if (error.request) {
                // Request dibuat tapi tidak ada respons
                if (error.code === "ECONNABORTED") {
                  errorMessage =
                    "Koneksi timeout. Periksa koneksi internet Anda.";
                } else {
                  errorMessage =
                    "Tidak dapat terhubung ke server. Periksa koneksi internet dan konfigurasi API.";
                }
              } else {
                // Error lainnya
                errorMessage = `Error: ${
                  error.message || "Terjadi kesalahan tidak diketahui"
                }`;
              }

              console.error("Login error:", error);
              alert(errorMessage);
              setLoginProses(false);
            });
        })
        .catch((error) => {
          let errorMessage = "Terjadi kesalahan saat mengambil data pengguna.";

          if (error.code) {
            switch (error.code) {
              case "PERMISSION_DENIED":
                errorMessage =
                  "Akses database ditolak. Periksa konfigurasi Firebase.";
                break;
              case "UNAVAILABLE":
                errorMessage =
                  "Database tidak tersedia. Silakan coba lagi nanti.";
                break;
              case "TIMEOUT":
                errorMessage =
                  "Timeout saat mengambil data. Periksa koneksi internet.";
                break;
              default:
                errorMessage = `Database error: ${error.message}`;
            }
          }

          console.error("Firebase database error:", error);
          alert(errorMessage);
          setLoginProses(false);
        });
    })
    .catch((error) => {
      let errorMessage = "Email atau password salah.";

      if (error.code) {
        switch (error.code) {
          case "auth/user-not-found":
            errorMessage = "Email tidak terdaftar dalam sistem.";
            break;
          case "auth/wrong-password":
            errorMessage = "Password yang Anda masukkan salah.";
            break;
          case "auth/invalid-email":
            errorMessage = "Format email tidak valid.";
            break;
          case "auth/user-disabled":
            errorMessage = "Akun pengguna telah dinonaktifkan.";
            break;
          case "auth/too-many-requests":
            errorMessage =
              "Terlalu banyak percobaan login. Silakan coba lagi nanti.";
            break;
          case "auth/network-request-failed":
            errorMessage =
              "Gagal terhubung ke server. Periksa koneksi internet.";
            break;
          default:
            errorMessage = `Authentication error: ${error.message}`;
        }
      }

      console.error("Firebase authentication error:", error);
      alert(errorMessage);
      setLoginProses(false);
    });
};

export const loginUser2 = (email, password) => {
  return (dispatch) => {
    dispatchLoading(dispatch, LOGIN_USER);
    axios({
      method: "post",
      url: ADMINS_LOGIN,
      timeout: API_TIMEOUT,
      data: { username: email, password: password },
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          dispatchError(dispatch, LOGIN_USER, "error");
        } else {
          //BERHASIL
          if (response.data.success == 0) {
            dispatchError(dispatch, LOGIN_USER, "error");
          } else {
            dispatchSuccess(
              dispatch,
              LOGIN_USER,
              response.data.data ? response.data.data : []
            );
          }
        }
      })
      .catch((error) => {
        // ERROR
        dispatchError(dispatch, LOGIN_USER, error);
      });
  };
};

export const checkLogin = (navigate) => {
  if (window.localStorage.getItem("user")) {
    const user = JSON.parse(window.localStorage.getItem("user"));

    FIREBASE.database()
      .ref(`users/${user.uid}`)
      .once("value")
      .then((resDB) => {
        if (resDB.val()) {
          navigate("/admin/dashboard");
        } else {
          navigate("/authentication/sign-in/cover");
        }
      })
      .catch((error) => {
        navigate("/authentication/sign-in/cover");
      });
  } else {
    navigate("/authentication/sign-in/cover");
  }
};

export function logoutUser(navigate) {
  localStorage.removeItem("user");
  navigate("/authentication/sign-in/cover");
}
